import React, {useState, useCallback} from 'react';
import Map from './components/Map';
import './App.css';


function App() {  
  return (
    <div className="App">
      <Map />
    </div>
  );
}

export default App;
